<template>
	<div class="agreement">
		<div class="init">
			<div class="val">
				<router-link to="/index" class="btn">
				캠페인을 실행하세요
				</router-link>
			</div>
		</div>
	</div>

</template>

<script>
	import Vue from 'vue';
	export default {
		name: "ad",
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn"
			};
		},
		mounted() {
			this.$parent.footer('index',false);
		},
		methods: {
			
		}
	};
</script>
<style lang="less" scoped>
	.agreement div{
		font-size: 16px;
	}
	.agreement{
		background: url(../images/index/ad.jpg) no-repeat top;
		background-size: cover;
		height: 100%;
	}
	.val {
	    width: 100%;
	    position: absolute;
	    top: 360px;
	    left: 50%;
	    transform: translateX(-50%);
	    color: #fff;
	    text-align: center;
	}
	.btn {
	    width: 240px;
	    height: 35px;
	    background-color: #34ce58;
	    color: #fff;
	    font-size: 12px;
	    line-height: 35px;
	    border-radius: 17px;
	    margin: 0 auto;
		display: block;
	}
	.init {
	    content: " ";
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background-color: rgba(0,0,0,.5);
	}
</style>
